import { Label } from '@/components/ui-kit/label';

import { FieldRendererProps } from '../types';
import { resolveTemplateVariables } from '../utils';

/**
 * Checkbox Field Renderer
 */
export function CheckboxField({
  field,
  value,
  onChange,
  error,
  formData,
  enrichmentContext,
}: FieldRendererProps) {
  // Resolve template variables
  const resolvedLabel = resolveTemplateVariables(field.label, formData, enrichmentContext);
  const resolvedHelpText = resolveTemplateVariables(field.helpText, formData, enrichmentContext);

  return (
    <div className="space-y-2">
      <div className="flex items-start gap-3 mb-2">
        <input
          id={field.name}
          type="checkbox"
          checked={Boolean(value)}
          onChange={(e) => onChange(field.name, e.target.checked)}
          className="h-4 w-4 mt-1 rounded border-secondary-100 text-selise-blue-500 accent-selise-blue-500 focus:ring-selise-blue-500"
        />
        <div>
          <Label
            htmlFor={field.name}
            className="cursor-pointer text-base font-semibold font-nunito text-primary-light"
          >
            {resolvedLabel}
            {field.required && <span className="text-destructive ml-1">*</span>}
          </Label>
          {resolvedHelpText && (
            <p className="text-sm text-secondary-300 mt-0.5">{resolvedHelpText}</p>
          )}
        </div>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
